module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-submit-review.3ad54f75.png";